module.exports = __webpack_public_path__ + "img/c12.255e4b15.png";